import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Page Routing
import { PagesRoutingModule } from './pages-routing.module';
import { SharedModule } from "../shared/shared.module";
import { LegalDocumentComponent } from './extrapages/legal-document/legal-document.component';
import { ExcluirDadosComponent } from './extrapages/excluir-dados/excluir-dados.component';


@NgModule({
  declarations: [
    LegalDocumentComponent,
    ExcluirDadosComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PagesRoutingModule,
    SharedModule,
  ]
})
export class PagesModule { }
